export default "__VITE_ASSET__BvxUaZBR__"